import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useScrollReveal from '../hooks/useScrollReveal';

const FeaturedProjects = () => {
  useScrollReveal();
  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();

  const projects = [
    {
      id: 1,
      title: "E-Commerce Platform",
      description: "High-performance online store with real-time analytics",
      image: "https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
      tags: ["React", "Node.js", "MongoDB"],
      details: {
        client: "Fashion Retail Co.",
        challenge: "Needed a scalable solution for seasonal traffic spikes",
        solution: "Built with server-side rendering and CDN integration",
        results: "300% increase in mobile conversions"
      }
    },
    {
      id: 2,
      title: "Data Analytics Dashboard",
      description: "Interactive visualization platform for business intelligence",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1115&q=80",
      tags: ["React", "Python", "PostgreSQL"],
      details: {
        client: "Financial Services Inc.",
        challenge: "Legacy system couldn't handle real-time data",
        solution: "Custom-built data pipelines with React frontend",
        results: "80% reduction in report generation time"
      }
    },
    {
      id: 3,
      title: "Enterprise CMS",
      description: "Custom content management system for large organizations",
      image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
      tags: ["React", "Node.js", "AWS"],
      details: {
        client: "Global Media Group",
        challenge: "Needed multi-site management capabilities",
        solution: "Headless CMS with centralized content hub",
        results: "50% faster content publishing across 12 brands"
      }
    }
  ];

  const handleViewDetails = (projectId, e) => {
    e.preventDefault();
    const project = projects.find(p => p.id === projectId);
    if (project) {
      navigate(`/work/${projectId}`, { state: { project } });
      window.scrollTo(0, 0);
    } else {
      console.error(`Project with ID ${projectId} not found`);
      navigate('/work');
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (scrollRef.current) {
        const nextIndex = (activeIndex + 1) % projects.length;
        const cardWidth = scrollRef.current.offsetWidth;
        scrollRef.current.scrollTo({
          left: cardWidth * nextIndex,
          behavior: 'smooth'
        });
        setActiveIndex(nextIndex);
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [activeIndex, projects.length]);

  const goToSlide = (index) => {
    if (scrollRef.current) {
      const cardWidth = scrollRef.current.offsetWidth;
      scrollRef.current.scrollTo({
        left: cardWidth * index,
        behavior: 'smooth'
      });
      setActiveIndex(index);
    }
  };

  return (
    <section className="featured-section">
            <div className="page-title in-view">
              <h2>Featured Projects</h2>
              <p className="page-subtitle">Selected projects showcasing our expertise</p>
            </div>
            <div className="projects__grid">
              {projects.map(project => (
                <div className="project-card fade-in" key={project.id}>
                  <div className="project-card__image">
                    <img src={project.image} alt={project.title} loading="lazy" />
                    <div className="project-card__overlay">
                      <Link 
                        to={`/projects/${project.id}`}
                        className="button"
                      >
                        View Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="project-card__content">
                    <h3 className="project-card__title">{project.title}</h3>
                    <p>{project.description}</p>
                    <div className="project-card__tech">
                      {project.tags.map(tag => (
                        <span className="tech-tag" key={tag}>{tag}</span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
  );
};

export default FeaturedProjects;